import React, { useEffect, useState, useContext } from 'react'
import { Button, Col, Row, message, Select, DatePicker, Form, Input, Upload, Spin, Switch, Image, UploadFile, Modal } from 'antd'
import ChooseVehicle from '../chooseVehicle'
import position from '@/assets/images/position.png'
import debounce from 'lodash/debounce'
import moment from 'moment'
import '../quickBilling.less'
import { YhBox } from '@/components/YhBox'
import { getBaseImgLookUrl, getBaseRequestUrl, getBaseUploadData, getToken, getBaseImgUploadUrl } from '@/utils/constants'
import { useDictModel } from '@/views/base/dict/dictModel'
import { DictCodeEnmu } from '@/types/VrmSaDictEnums'
import { fileDownload } from "@/utils/exportFile";
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { momentFormats } from '@/utils/utils'
import useGlobalModel from '@/model/globalModel'
import { reportBillService } from '../../reportBill/reportBillService'
import useNavModel from '@/model/navModel'

const { Option } = Select

export default () => {
    const { getSelectedDictOne } = useDictModel();
    const { shopAndOrg: { shopCode, shopId, shopName }, user, shopAndOrg } = useGlobalModel();

    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const [form] = Form.useForm<any>()
    const [vehicleVisible, setVehicleVisible] = useState<boolean>(false)
    const [licenseFileList, setLicenseFileList] = useState<any>({}) //图片list
    const [previewImage, setpreviewImage] = useState<string>('') //预览展示的行驶证
    const [previewVisible, setpreviewVisible] = useState<boolean>(false) //预览图片使用的dialog
    const [uploading, setUploading] = useState<boolean>(false)
    const [imgInfo, setImgInfo] = useState<any>({})
    const [faultImageFileList, setFaultImageFileList] = useState<UploadFile[]>([]) // 故障图片列表

    useEffect(() => {
        form.setFieldsValue({
            shopId: shopId,
            shopName: shopName,
            shopCode: shopCode,
            serviceLocationCode: "service-address.inside",
            serviceLocationName: "站内维修",
        })
    }, [])

    const resetData = () => {
        form.resetFields()
    }

    // 获取中文部分（用于品牌名称）
    const GetChinese = (str: string): string => {
        return str.replace(/[^\u4e00-\u9fa5]/g, '')
    }

    // 移除中文部分（用于车型）
    const RemoveChinese = (str: string): string => {
        return str.replace(/[\u4e00-\u9fa5]/g, '')
    }

    const handleChangebrandName = (value: string, option: any) => {
        form.setFieldsValue({
            brandName: option.info.label,
            brandCode: option.info.value,
        })
    }

    const handleChangeVehicleType = (value: string, option: any) => {
        form.setFieldsValue({
            vehicleTypeName: option.info.label,
            vehicleTypeCode: option.info.value,
        })
    }

    const handleChangeServiceNatureCode = (value: string, option: any) => {
        form.setFieldsValue({
            serviceNatureName: option.info.label,
            serviceNatureCode: option.info.value,
        })
    }
    const handleChangeorderType = (value: string, option: any) => {
        form.setFieldsValue({
            orderType: option.info.value,
        })
    }
    const handleChangeServiceLocationCode = (value: string, option: any) => {
        form.setFieldsValue({
            serviceLocationName: option.info.label,
            serviceLocationCode: option.info.value,
        })
    }

    // 图片上传处理
    const handleImgChange = async (info: any) => {
        let newFileList = [...info.fileList]
        // 限制只能上传一张图片
        newFileList = newFileList.slice(-1)
        if (info.file.status === 'uploading') {
            setUploading(true)
            return
        }
        if (info.file.status === 'done') {
            setUploading(false)
            let { words_result, error_msg } = info?.file?.response;
            let imgVal = {
                vehicleCode: words_result['号牌号码']?.words || '',
                vehicleType: words_result['车辆类型']?.words || '',
                brandName: GetChinese(words_result['品牌型号']?.words || ''),
                vehicleModelId: RemoveChinese(words_result['品牌型号']?.words || ''),
                vehicleNature: words_result['使用性质']?.words || '',
                vehicleVin: words_result['车辆识别代号']?.words || '',
                engineCode: words_result['发动机号码']?.words || '',
                drivingSignDate: momentFormats(words_result['注册日期']?.words || ''),
                customerName: words_result['所有人']?.words || '',
                customerAddress: words_result['住址']?.words || ''
            };
            let brand = getSelectedDictOne(DictCodeEnmu.VEHICLE_BRAND).filter((e: any) => e.label == imgVal.vehicleModelId || e.label == imgVal.brandName.replace('牌', '')) ?? [];
            let vehicleType = getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE).filter((e: any) => e.label == imgVal.vehicleType || e.value == imgVal.vehicleType) ?? [];
            setLicenseFileList({
                confirmVehicleCode: imgVal.vehicleCode,
                confirmBrandCode: brand.length > 0 ? brand[0].value : '',
                confirmBrandName: brand.length > 0 ? brand[0].label : '',
                confirmCustomerName: imgVal.customerName,
                confirmVinCode: imgVal.vehicleVin,
                confirmVehicleTypeCode: vehicleType.length > 0 ? vehicleType[0].value : '',
                confirmVehicleTypeName: vehicleType.length > 0 ? vehicleType[0].label : '',
            })
            setImgInfo(imgVal)
            setVehicleVisible(true)
        } else if (info.file.status === 'error') {
            setUploading(false)
            message.error('上传失败，请重试')
            setLicenseFileList({})
        } else if (info.file.status === 'removed') {
            setLicenseFileList({})
            // 清空图像识别信息
            setImgInfo({})
        }
    }



    // 故障图片预览 - 完全按照参考代码的方式
    const onLookPreview = (file: UploadFile) => {
        let uid = '';
        if (typeof file === 'string') {
            uid = file;
        } else if (file.response?.retData) {
            uid = file.response.retData;
        } else if (file.uid) {
            uid = file.uid;
        }
        Modal.info({
            title: '故障图片预览(点击图片放大)',
            content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
            okText: '确定',
            centered: true,
            width: 800,
        });
    }

    // 故障图片表单验证规则 - 完全按照参考代码的方式
    const normFaultImageFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        const { file, fileList } = e;
        if (file.status === 'done') {
            if (file.response?.retCode === 0) {
                const imgId = file.response.retData;
                return fileList.map((item: any) => item === file.uid ? imgId : item);
            } else {
                message.error('文件上传失败，请重新上传!');
                return fileList.filter((item: any) => item !== file.uid);
            }
        }
        if (file.status === 'error') {
            message.error('文件上传失败，请重新上传!');
            return fileList.filter((item: any) => item !== file.uid);
        }
        return fileList;
    }

    //表单绑定图片
    const normFile = (e: any) => {
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    //车辆确认
    const vehicleConfirm = async (data: any) => {
        form.setFieldsValue({
            ...data,
            licensePlate: data.confirmVehicleCode,
            brandName: data.confirmBrandName,
            brandCode: data.confirmBrandCode,
            contact: data.contact,
            phone: data.phone,
            vin: data.confirmVinCode,
            vehicleTypeCode: data.confirmVehicleTypeCode,
            vehicleTypeName: data.confirmVehicleTypeName,
            customerName: data.customerChoose === '1' ? data.existCustomerName : data.confirmCustomerName,
        })
        setVehicleVisible(false)
    }

    // 提交
    const onOk = async () => {
        form.validateFields().then(async (res) => {
            let param = {
                ...res,
                fileMsg: res.fileList ? res.fileList.map((item: any) => item.response.retData).toString() : ''
            }
            try {
                const result = await reportBillService.quickBillingInsert(param);
                if (result) {
                    message.success('快速开单成功');
                    resetData();
                    replaceNav(selectedNavId, "19-2")
                } else {
                    message.warning(result);
                }


            } catch (error) {
                console.error('获取客户信息失败', error);
                message.warning('查询客户信息失败');
            }
        })
    }

    return (
        <Form form={form}>
            <YhBox title="快速开单">
                <div className="quickBox">
                    <div className="photo" style={{ height: 720 }}>
                        <Form.Item
                            label=""
                            name="driverCardImg"
                            valuePropName="fileList"
                            getValueFromEvent={normFile}
                        >
                            <Upload
                                action={`${getBaseRequestUrl()}/zzw-vrm/repairReport/vehicle_license`}
                                headers={{
                                    authorization: getToken(),
                                }}
                                listType="picture-card"
                                className="avatar-uploader quickBilling-uploader"
                                onChange={handleImgChange}
                                maxCount={1}
                            >
                                {licenseFileList.confirmVehicleCode ? null : <Button>上传行驶证</Button>}
                            </Upload>
                        </Form.Item>
                    </div>
                    <div className="form">
                        <div style={{ height: 260, margin: '0 -10px 20px 40px', padding: 20, border: '1px solid #d9d9d9', borderRadius: 5 }}>
                            <Row>
                                <Col span={24} style={{ paddingBottom: 5 }}>
                                    <div className="list-name">
                                        <span style={{ margin: 10, fontWeight: 'bold', color: 'black', fontSize: 17 }}>行驶证信息</span>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <Form.Item
                                        label="车辆牌照"
                                        name="licensePlate"
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入车辆牌照',
                                            },
                                            {
                                                pattern: /^[\u4E00-\u9FA5][\da-zA-Z]{6,7}$/,
                                                message: '请输正确的车辆牌照',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="请输正确的车辆牌照" disabled />
                                    </Form.Item>
                                    {vehicleVisible && (
                                        <ChooseVehicle
                                            visible={vehicleVisible}
                                            vehicleData={licenseFileList}
                                            onClose={() => {
                                                setVehicleVisible(false)
                                            }}
                                            onSuc={vehicleConfirm}
                                        />
                                    )}
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        name="vehicleTypeName"
                                        label="车辆类型"
                                        rules={[
                                            {
                                                required: true,
                                                message: '请选择车辆类型',
                                            },
                                        ]}
                                    >
                                        <Select placeholder="请选择车辆类型" onSelect={handleChangeVehicleType} style={{ width: '100%' }}>
                                            {getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE).map((item: any) => (
                                                <Option value={item.label} key={item.value} info={item}>
                                                    {item.label}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <Form.Item
                                        name="brandName"
                                        label="车辆品牌"
                                        rules={[
                                            {
                                                required: true,
                                                message: '请选择车辆品牌',
                                            },
                                        ]}
                                    >
                                        <Select placeholder="请选择车辆品牌" onSelect={handleChangebrandName} style={{ width: '100%' }}>
                                            {getSelectedDictOne(DictCodeEnmu.VEHICLE_BRAND).map((item: any) => (
                                                <Option value={item.label} key={item.value} info={item}>
                                                    {item.label}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label={<span style={{ marginLeft: 11 }}>车辆里程</span>} name="mileage">
                                        <Input placeholder="请输入车辆里程" />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label={<span style={{ marginLeft: 11 }}>发动机号</span>} name="vin" rules={[
                                        {
                                            required: true,
                                            message: '请输入发动机号',
                                        },
                                    ]}>
                                        <Input placeholder="请输入发动机号" />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label={<span style={{ marginLeft: 11 }}>所属站点</span>} name="shopName">
                                        <Input placeholder="请输入所属站点" disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Form.Item
                                        label="客户名称"
                                        name="customerName"
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入客户名称',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="请输入客户名称" />
                                    </Form.Item>
                                    <Form.Item hidden name="brandCode">
                                        <Input />
                                    </Form.Item>
                                    <Form.Item hidden name="vehicleTypeCode">
                                        <Input />
                                    </Form.Item>
                                    <Form.Item hidden name="serviceLocationCode">
                                        <Input />
                                    </Form.Item>
                                    <Form.Item hidden name="serviceNatureCode">
                                        <Input />
                                    </Form.Item>
                                    <Form.Item hidden name="shopId">
                                        <Input />
                                    </Form.Item>
                                    <Form.Item hidden name="shopCode">
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div style={{ height: 'auto', margin: '0 -10px 20px 40px', padding: 20, border: '1px solid #d9d9d9', borderRadius: 5 }}>
                            <Row>
                                <Col span={24} style={{ paddingBottom: 5 }}>
                                    <div className="list-name">
                                        <span style={{ margin: 10, fontWeight: 'bold', color: 'black', fontSize: 17 }}>报修信息</span>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Row gutter={24}>
                                        {/* <Col span={24}>
                                            <Form.Item
                                                name="orderType"
                                                label="工单类型"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '请选择工单类型',
                                                    },
                                                ]}
                                            >
                                                <Select showSearch placeholder="请选择工单类型" onSelect={handleChangeorderType} style={{ width: '100%' }}>
                                                    {getSelectedDictOne(DictCodeEnmu.MAINTENANCEORDER_TYPE).map((item: any) => (
                                                        <Option value={item.label} key={item.value} info={item}>
                                                            {item.label}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col> */}
                                        <Col span={12}>
                                            <Form.Item
                                                name="serviceNatureName"
                                                label="维修类型"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '请选择维修类型',
                                                    },
                                                ]}
                                            >
                                                <Select showSearch placeholder="请选择维修类型" onSelect={handleChangeServiceNatureCode} style={{ width: '100%' }}>
                                                    {getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE).map((item: any) => (
                                                        <Option value={item.label} key={item.value} info={item}>
                                                            {item.label}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label="服务地点"
                                                name="serviceLocationName"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '请选择服务地点',
                                                    },
                                                ]}
                                            >
                                                <Select showSearch placeholder="请选择服务地点" onSelect={handleChangeServiceLocationCode} style={{ width: '100%' }}>
                                                    {[{ label: '站内维修', value: 'service-address.inside' }, { label: '站外救援', value: 'service-address.outside' }].map((item: any) => (
                                                        <Option value={item.label} key={item.value} info={item}>
                                                            {item.label}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={24}>
                                        <Col span={12}>
                                            <Form.Item
                                                name="contact"
                                                label={<span style={{ marginLeft: 14 }}>送修人</span>}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '请输入送修人',
                                                    },
                                                ]}
                                            >
                                                <Input placeholder="请输入送修人" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label="联系电话"
                                                name="phone"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '请输入联系电话',
                                                    },
                                                    {
                                                        message: '联系电话有误',
                                                        pattern: /^[0-9]\d{10}$/,
                                                    },
                                                ]}
                                            >
                                                <Input placeholder="请输入联系电话" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item
                                                label="故障描述"
                                                name="faultDesc"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '请输入故障描述',
                                                    },
                                                ]}
                                            >
                                                <Input.TextArea rows={2} placeholder="请输入故障描述" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    {/* 新增故障图片上传部分 - 完全按照参考代码的方式 */}
                                    <Row>
                                        <Col span={24}>
                                            <div style={{ marginBottom: 20 }}>
                                                <span style={{ fontWeight: "bold", width: 80, display: "inline-block", verticalAlign: "top", marginBottom: '10px' }}>
                                                    故障图片:
                                                </span>
                                                <Form.Item
                                                    name="fileList"
                                                    valuePropName="fileList"
                                                    getValueFromEvent={normFaultImageFile}
                                                    style={{ display: 'inline-block', width: 'calc(100% - 80px)' }}
                                                >
                                                    <Upload
                                                        onPreview={onLookPreview}
                                                        name="file"
                                                        action={getBaseImgUploadUrl()}
                                                        data={getBaseUploadData()}
                                                        listType="picture-card"
                                                        multiple
                                                        maxCount={9}
                                                        accept="image/*"
                                                    >
                                                        {
                                                            (Array.isArray(form.getFieldValue('fileList')) ? form.getFieldValue('fileList').length : 0) < 9
                                                            && (
                                                                <div style={{ marginTop: '15px' }}>
                                                                    <UploadOutlined />
                                                                    <div>上传照片</div>
                                                                    <div style={{ color: '#4abca5', fontSize: '13px' }}>(最多上传9张)</div>
                                                                </div>
                                                            )
                                                        }
                                                    </Upload>
                                                </Form.Item>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Button className="btn-item" shape="round" onClick={onOk} style={{ marginLeft: '45%', marginTop: 20 }}>
                                                确认提交
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </YhBox>
        </Form>
    )
}